// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import _ from 'lodash';
// COMPONENTS
import { Divider } from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import { ModalProgressBar } from '../../../../_metronic/_partials/controls';
import { Form, Modal, Spinner, Button } from 'react-bootstrap';
import Select from 'react-select';
import SVG from 'react-inlinesvg';
import MUIDataTable from 'mui-datatables';
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import ProjectValidator from '../../../../helpers/validators/ProjectValidator';
import { getInputClasses, setToOptionModel } from '../../../../helpers/helper';
import * as projectTypeService from '../../../../services/companyData/projectTypeService';
import * as projectService from '../../../../services/companyData/projectService';
import * as formService from '../../../../services/form/formService';
import ProjectFormValidator from '../../../../helpers/validators/ProjectFormValidator';
import * as projectFormService from '../../../../services/companyData/projectFormService';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

const ProjectDetailPage = (props) => {
  const { projectId } = useParams();

  const initialValues = {
    id: 0,
    projectTypeId: null,
    projectSubTypeId: null,
    name: '',
    description: '',
    projectForms: [],
  };

  const initialProjectForm = {
    id: 0,
    projectId: projectId,
    formId: null,
    frequency: '',
    isShareable: false,
  };
  const frequencyOptions = ['Once', 'Daily'].map((x) => setToOptionModel(x, x.toUpperCase()));

  const { showConfirmModal, hideConfirmModal, setProcessing, navigation, showAlert, history } = props;
  const [loading, setLoading] = useState(true);
  const [savedProject, setSavedProject] = useState(initialValues);
  const [forms, setForms] = useState([]);
  const [projectTypesList, setProjectTypeList] = useState([]);
  const [projectSubTypesList, setProjectSubTypeList] = useState([]);
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [selectedProjectSubType, setSelectedProjectSubType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [projectForm, setProjectForm] = useState(initialProjectForm);
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [projectForms, setProjectForms] = useState([]);

  useEffect(() => {
    loadDropDownAndFields();
    fetchProjectForms();
  }, [projectId]);

  const loadDropDownAndFields = async () => {
    var projects = await fetchProjectTypeAndSubType();
    var forms = await fetchForms();

    if (projectId > 0) {
      await fetchProject(projects);
    }
  };

  const fetchProjectTypeAndSubType = async () =>
    await projectTypeService.getProjectTypesWithSubTypes().then((res) => {
      setProjectTypeList(res);

      return res;
    });

  const fetchForms = async () =>
    await formService.getAllForms().then((res) => {
      setForms(res);

      return res;
    });

  const fetchProjectForms = () => {
    setLoading(true);
    projectFormService
      .getProjectFormsByProjectId(projectId)
      .then((res) => {
        setProjectForms(res);
        setLoading(false);
      })
      .catch((ex) => showAlert({ message: ex.message, variant: 'error' }));
  };

  const fetchProject = async (projects) => {
    await projectService.getProjectById(projectId).then((res) => {
      setSavedProject(res);

      var savedProjectType = projects.find((x) => x.id == res.projectTypeId);
      var projectSubTypeList = savedProjectType.projectSubTypes;

      setSelectedProjectType(setToOptionModel(savedProjectType.name, savedProjectType.id));
      setProjectSubTypeList(projectSubTypeList);

      var savedProjectSubType = projectSubTypeList.find((x) => x.id == res.projectSubTypeId);
      setSelectedProjectSubType(setToOptionModel(savedProjectSubType.name, savedProjectSubType.id));
    });
  };

  const saveProject = (values, setStatus, setSubmitting) => {
    setSubmitting(true);
    projectService
      .saveProject(values)
      .then((res) => {
        showAlert({ message: res.message, variant: 'success' });
        if (values.id === 0) {
          history.push('/company-data/project/edit/' + res.projectId);
        }
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      })
      .finally(() => setSubmitting(false));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: savedProject,
    validationSchema: ProjectValidator,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveProject(values, setStatus, setSubmitting);
    },
  });

  const projectFormFormik = useFormik({
    enableReinitialize: true,
    initialValues: projectForm,
    validationSchema: ProjectFormValidator,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      projectFormService
        .saveProjectForm({ ...values, projectId: savedProject.id })
        .then((res) => {
          fetchProjectForms();
          handleModalClose();
          showAlert({ message: res.message, variant: 'success' });
        })
        .catch((ex) => {
          showAlert({ message: ex.message, variant: 'error' });
        })
        .finally(() => setSubmitting(false));
    },
  });

  const handleProjecFormDelete = (projectFormId) => {
    setProcessing();
    projectFormService
      .deleteProjectForm(projectFormId)
      .then((res) => {
        fetchProjectForms();
        showAlert({ message: res.message, variant: 'success' });
        hideConfirmModal();
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      });
  };

  const getProjectFormDetailAndOpenModal = (projectFormId) => {
    projectFormService
      .getProjectFormById(projectFormId)
      .then((res) => {
        setProjectForm(res);
        let formSelected = forms.find((x) => x.id == res.formId);
        if (formSelected) {
          setSelectedForm(setToOptionModel(formSelected.name, formSelected.id));
        }
        setSelectedFrequency(frequencyOptions.find((x) => x.value === res.frequency));
        setIsModalOpen(true);
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'danger' });
      });
  };

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        width: 1,
        download: false,
        setCellProps: () => ({
          'data-aes-field': 'actions',
        }),
        setCellHeaderProps: () => ({
          'data-aes-field': 'actions',
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className='aes-admin-listing-actions'>
              <button
                type='button'
                onClick={() => getProjectFormDetailAndOpenModal(projectForms[dataIndex].id)}
                className='btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5'
              >
                Edit
              </button>
              <button
                type='button'
                onClick={() =>
                  showConfirmModal({
                    title: 'Delete Project',
                    text: 'Are you sure you want to delete this project?',
                    rightBtnText: 'Confirm',
                    btnAction: () => handleProjecFormDelete(projectForms[dataIndex].id),
                  })
                }
                className='btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1'
              >
                Delete
              </button>
            </div>
          );
        },
      },
    },
    {
      name: 'formName',
      label: 'Form Name',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'primary',
          'data-aes-label': 'Form Name',
        }),
        setCellHeaderProps: () => ({
          'data-aes-field': 'primary',
        }),
      },
    },
    {
      name: 'frequency',
      label: 'Frequency',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'detail',
          'data-aes-label': 'Frequency',
        }),
        setCellHeaderProps: () => ({
          'data-aes-field': 'detail',
        }),
        customBodyRenderLite: (dataIndex) => <p>{_.startCase(_.toLower(projectForms[dataIndex].frequency))}</p>,
      },
    },
    // {
    //     name: "isShareable",
    //     label: "Is Shareable",
    //     options: {
    //         filter: true,
    //         sort: true,
    //         customBodyRenderLite: (dataIndex) => {
    //             return (
    //                 <>
    //                     <SVG
    //                         className="h-50 align-self-center"
    //                         src={toAbsoluteUrl(projectForms[dataIndex].isShareable ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
    //                     >
    //                     </SVG>
    //                 </>
    //             );
    //         }
    //     }
    // }
  ];

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedFrequency(null);
    setSelectedForm(null);
    setProjectForm(initialProjectForm);
    projectFormFormik.resetForm();
  };

  return (
    <>
      <Modal centered size='lg' show={isModalOpen} onHide={handleModalClose}>
        <form className='card card-custom' onSubmit={projectFormFormik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Project Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='form'>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Form</label>
                <div className='col-lg-9 col-xl-9'>
                  <Select
                    value={selectedForm}
                    options={forms.map((x) => setToOptionModel(x.name, x.id))}
                    onChange={(selectedOption) => {
                      selectedOption = selectedOption === null ? [] : selectedOption;
                      setSelectedForm(selectedOption);
                      projectFormFormik.setFieldValue('formId', selectedOption.value);
                    }}
                    className={`${getInputClasses(projectFormFormik, 'formId')}`}
                    name='formId'
                    placeholder='Select Form'
                  />
                  {projectFormFormik.touched.formId && projectFormFormik.errors.formId ? (
                    <div className='invalid-feedback'>{projectFormFormik.errors.formId}</div>
                  ) : null}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Frequency</label>
                <div className='col-lg-9 col-xl-9'>
                  <Select
                    value={selectedFrequency}
                    options={frequencyOptions}
                    onChange={(selectedOption) => {
                      selectedOption = selectedOption === null ? [] : selectedOption;
                      setSelectedFrequency(selectedOption);
                      projectFormFormik.setFieldValue('frequency', selectedOption.value);
                    }}
                    className={`${getInputClasses(projectFormFormik, 'frequency')}`}
                    name='frequency'
                    placeholder='Select Frequency'
                  />
                  {projectFormFormik.touched.frequency && projectFormFormik.errors.frequency ? (
                    <div className='invalid-feedback'>{projectFormFormik.errors.frequency}</div>
                  ) : null}
                </div>
              </div>
              {/* <div className="form-group row">
                                <label htmlFor="isShareable" className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Is Shareable?
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="checkbox-list">
                                        <label className="checkbox checkbox-primary">
                                            <input
                                                type="checkbox"
                                                name="isShareable"
                                                id="isShareable"
                                                checked={projectFormFormik.values.isShareable}
                                                {...projectFormFormik.getFieldProps("isShareable")}
                                            />
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div> */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleModalClose}>
              Close
            </Button>
            <button
              type='submit'
              className='btn btn-success mr-2'
              disabled={projectFormFormik.isSubmitting || (projectFormFormik.touched && !projectFormFormik.isValid)}
            >
              Save
              {projectFormFormik.isSubmitting}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <form className='card card-custom card-stretch' onSubmit={formik.handleSubmit}>
        {loading && <ModalProgressBar />}
        <div className='card-header py-3'>
          <div className='card-title align-items-start flex-column'>
            <h3 className='card-label font-weight-bolder text-dark'>{savedProject.id > 0 ? 'Edit' : 'Add'} Project</h3>
            <span className='text-muted font-weight-bold fz-xs mt-1'>
              Please fill out the form below. Fields marked as <code>*</code> are required.
            </span>
          </div>
          <div className='card-toolbar'>
            <button type='submit' className={`btn btn-success mr-2`} disabled={formik.isSubmitting || (formik.touched && !formik.isValid)}>
              Save Project
              {formik.isSubmitting}
            </button>
            <button type='button' onClick={() => history.goBack()} className='btn btn-danger'>
              Cancel
            </button>
          </div>
        </div>
        <div className='form'>
          <div className='card-body' style={{ marginTop: '-22px' }}>
            <div className='row'>
              <label className='col-xl-3'></label>
              <div className='col-lg-9 col-xl-6'>
                <h5 className='mt-lg-10 mb-6 fz-md fw-700 c-primary'>Basic Info</h5>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Project Name*</label>
              <div className='col-lg-9 col-xl-6'>
                <input
                  type='text'
                  placeholder='Enter a Project Name'
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'name')}`}
                  name='name'
                  {...formik.getFieldProps('name')}
                />
                {formik.touched.name && formik.errors.name ? <div className='invalid-feedback'>{formik.errors.name}</div> : null}
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Project Type*</label>
              <div className='col-lg-9 col-xl-6'>
                <Select
                  isDisabled={savedProject.id > 0}
                  value={selectedProjectType}
                  options={projectTypesList.map((x) => setToOptionModel(x.name, x.id))}
                  onChange={(selectedOption) => {
                    setProjectSubTypeList([]);
                    setSelectedProjectSubType(null);
                    selectedOption = selectedOption === null ? [] : selectedOption;
                    setSelectedProjectType(selectedOption);
                    formik.setFieldValue('projectTypeId', selectedOption.value);
                    setProjectSubTypeList(projectTypesList.find((x) => x.id == selectedOption.value).projectSubTypes);
                  }}
                  className={`${getInputClasses(formik, 'projectTypeId')}`}
                  name='projectTypeId'
                  placeholder='Select Project Sub Types'
                />
                {formik.touched.projectTypeId && formik.errors.projectTypeId ? (
                  <div className='invalid-feedback'>{formik.errors.projectTypeId}</div>
                ) : null}
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Project Sub Type*</label>
              <div className='col-lg-9 col-xl-6'>
                <Select
                  isDisabled={savedProject.id > 0}
                  value={selectedProjectSubType}
                  options={projectSubTypesList.map((x) => setToOptionModel(x.name, x.id))}
                  onChange={(selectedOption) => {
                    selectedOption = selectedOption === null ? [] : selectedOption;
                    setSelectedProjectSubType(selectedOption);
                    formik.setFieldValue('projectSubTypeId', selectedOption.value);
                  }}
                  className={`${getInputClasses(formik, 'projectSubTypeId')}`}
                  name='projectSubTypeId'
                  placeholder='Select Project SubType'
                />
                {formik.touched.projectSubTypeId && formik.errors.projectSubTypeId ? (
                  <div className='invalid-feedback'>{formik.errors.projectSubTypeId}</div>
                ) : null}
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Description</label>
              <div className='col-lg-9 col-xl-6'>
                <div className='input-group input-group-lg input-group-solid'>
                  <Form.Control
                    as='textarea'
                    rows='5'
                    placeholder='Start typing...'
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'description')}`}
                    name='description'
                    {...formik.getFieldProps('description')}
                  />
                </div>
                {formik.touched.description && formik.errors.description ? (
                  <div className='invalid-feedback display-block'>{formik.errors.description}</div>
                ) : null}
              </div>
            </div>
            {savedProject.id > 0 && (
              <div className='aes-admin-listing-page aes-admin-listing-page--project-forms'>
                <div className='d-flex justify-content-between aes-admin-listing-heading'>
                  <div className='d-flex'>
                    <h5 className='mt-lg-10 mb-6 fz-md fw-700 c-primary'>Forms</h5>
                  </div>
                  <div className='d-flex align-items-center aes-admin-listing-heading-actions'>
                    <button type='button' onClick={() => setIsModalOpen(true)} className='btn btn-success mr-2 fit-content'>
                      Add Form
                    </button>
                  </div>
                </div>
                <Divider />
                <div className='container-fluid aes-admin-listing p-0'>
                  <MUIDataTable
                    className='aes-admin-listing-surface'
                    data={projectForms}
                    columns={columns}
                    options={{
                      responsive: 'standard',
                      rowsPerPage: 25,
                      rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                      selectableRows: 'none',
                      setTableProps: () => ({
                        className: 'aes-admin-listing-table',
                      }),
                      textLabels: {
                        body: {
                          noMatch: loading ? <Spinner animation='border' size='lg' variant='info' /> : 'Sorry, no matching records found.',
                        },
                      },
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default connect(null, { ...alert.actions, ...confirmModal.actions })(ProjectDetailPage);
